<template>
    <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12 v-if="item != 'multiple'">
                    <v-label>Pour confirmer, tapez <span class="headline"> "{{ item }}" </span> dans la case
                        ci-dessous</v-label>
                    <v-text-field v-model="code" label="*" required solo>
                    </v-text-field>
                </v-flex>

                <v-flex xs12 v-if="item != 'multiple'">
                    <v-label>Raison de suppression</v-label>
                    <v-text-field rows="3" v-model="reason" label="*" required solo>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="orange" @click="cancel()">Non</v-btn>
            <v-btn :loading="loading" rounded color="primary" @click="deleteItem()">Oui</v-btn>
            <!-- <v-btn :loading="loading" :disabled="loading || verify" rounded color="primary"
                @click="deleteItem()">Oui</v-btn> -->
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from "axios"
export default {
    name: 'delete-with-password',
    data() {
        return {
            loading: false,
            verify: true,
            code: '',
            password: '',
            reason: '',
            error: false,
            show: false,
        }
    },
    props: {
        item: {
            type: String,
            default: null
        },
        message: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
    },
    watch: {
        code: function () {
            if (this.code == this.item
                // && this.password.length >= 6
            ) {
                this.verify = false
            } else {
                this.verify = true
            }
            this.error = false
        },
        password: function () {
            if ((this.item == "multiple" || this.code == this.item)
                && this.password.length >= 6
            ) {
                this.verify = false
            } else {
                this.verify = true
            }
            this.error = false
        }
    },
    computed: {

    },
    methods: {
        cancel() {
            this.$emit('cancel');
            this.code = ''
            this.password = ''
            this.reason = ''
        },
        async deleteItem() {
            this.loading = true
            // const { data } = await axios.post('/api/users/verify-password', { password: this.password })
            // if (data == true) {
            this.$emit('deleteItem', {
                code: this.code,
                reason: this.reason
            });

            this.reason = ''
            this.code = ''
            //  this.password = ''
            // } else {
            //  this.error = true
            // }
            this.loading = false
        }
    }
}
</script>
<style>
.error-field .v-text-field__details {
    color: red;
    /* Couleur du texte d'erreur */
}

.error-field .v-input--solo .v-input__control .v-input__slot::before {
    border-bottom-color: red;
    /* Couleur de la bordure inférieure en cas d'erreur */
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DeleteWithPassword.vue